export enum Roles {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Employee = 'Employee',
  Analyst = 'Analyst',
  SuperViewer = 'SuperViewer',
}
